import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
window.bootstrap = bootstrap;
import '../../icon';
import '../../components/chat-now-button';
import './mhcorp.scss';
import '../../tab-deep-link';
import '../../hash-navigation-controller.js';
import '../../navtabs.js';
import '../../collapse.js';
import '../../text-links.js';
import '../../video/video.js';
import '../../video/video-modal.js';
import '../../video/wistia.js';
import '../../video/vidyard.js';
import '../../carousel.js';
import '../../blockquote.js';
import '../../accordion-tabs-bs5.js';
import '../../nested-modal.js';
import '../../stickyNav.js';
import '../../headers/containerV2.js';
import '../../headers/stickyHeader.js';
import '../../accordion.js';
import '../../multinav.js';
import '../../purchase-options.js';
import '../../card-buttons.js';
import '../../card-v2.js';
import './he-pdp/feature-highlight-cards.js';
import './he-pdp/backwards-compatibility.js';
import './he-pdp/royalty-purchase-options-dropdown-toggle.js';
import '../../scroll-container.js';
import '../../custom-select/custom-select.js';
import '../../button/hePdpStuInsBtnGroup.js';
import '../../popover.js';
import '../../globalNav/globalnav.js';
import '../../globalNav/regionSelector.js';
import '../../micrositenav.js';
import '../../animations/container-zoom.js';
import '../../animations/sal/sal.js';
import '../../image-with-overlay.js';
import '../../interactive-image-map.js';
import '../../he-events.js';
import '../../instructor-actions.js';
import '../../horizontal-tabs-scrolls.js';
import '../../dropdown.js';
import '../../modal.js';
import '../../social-share/facebookShare.js';
import '../../social-share/copyUrlButtonClick.js';
import '../../back-to-top/back-to-top.js';
import '../../faq/faq.js';
import '../../table/table.js';
import '../../headers/header.js';
import '../../tagToggle.js';
